export default "__VITE_ASSET__CQEVw63r__"